<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1 style="font-family:Calisto MT;font-size:20pt">Acknowledgment</h1>
<p style="text-align: center;">Thank you, Laura Paige and Mr. Becker,</p>
<p style="text-align: center;">for all your help with the book.</p>
<br/>
<p style="text-align: center;">And thank you to all the readers of my books, through all the adventures.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?0896026c